export default __webpack_public_path__ + "static/media/anthem-website-logos_fc.0b299cd5.webp";